import styled, { css } from "styled-components";
import { Card } from "@/components/shared-ui/Card/styled";

export const ServiceTargets = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.875rem;
  padding-bottom: 1rem;
  ${Card} {
    min-width: 0;
  }
`;

export const PageHeading = styled.h1`
  font-size: 1.5rem;
  line-height: 1;
  margin-top: 0;
  margin-bottom: 1rem;
  padding-bottom: 1.8rem;
  border-bottom: 1px solid ${(props) => props.theme.colors.light};
`;

export const ServiceTargetsContent = styled.div`
  h4 {
    margin: 0;
    ${(props) => props.theme.media.large} {
      font-size: 0.95rem;
      line-height: 1.125rem;
    }
  }

  h3 {
    font-size: 1rem;
    line-height: 1.25rem;

    ${(props) => props.theme.media.large} {
      font-size: 1.125rem;
      line-height: 1.5rem;
    }
  }
`;

// minmax(0, 1fr) and min-width: 0 let the areas shrink to the card width, so a wide
// table scrolls inside its area rather than pushing the whole card wider
export const TableWrapper = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 0.875rem;

  > div {
    min-width: 0;
  }
`;

// Scrolling sits on the table rather than the wrapper, so the area bars are not clipped
export const AreaTable = styled.div<{ isSuccessArea?: boolean }>`
  overflow-x: auto;

  ${(props) =>
    props.isSuccessArea &&
    css`
      tbody tr:not(:first-child) td:first-child {
        margin-left: 15px;
        display: block;
      }
    `}
`;

// The Card has 0.9rem of padding, and its InnerContainer adds another 0.9rem, so the
// bar extends by 1.8rem to reach the card edges. The text keeps its previous position.
export const AreaRow = styled.div`
  background: ${(props) => props.theme.gradients.light2};
  height: 48px;
  display: flex;
  align-items: center;
  margin: 0 -1.8rem;
  padding-left: calc(1.8rem + 15px);

  ${(props) => props.theme.media.large} {
    padding-left: 1.8rem;
  }
`;

export const ViewToggle = styled.div`
  margin-bottom: 1rem;
  align-self: flex-end;
  ${(props) => props.theme.media.medium} {
    margin-bottom: -1rem;
  }
`;
